import ThirdPrint from "./ThirdPrint";
import employeeLogo from "../../images/employee.png";
import jsPDF from "jspdf";
import { BoxesPacking } from "../features/BoxesPacking";
import Arabic from "../../images/arabic title.png";
import address from "../../images/arabic address.png";

function WarehousePrint(billNumber, customer, items, date, notes, doc, temp) {
  let companyCode = localStorage.getItem("companyCode");
  doc.setFontSize(10);
  doc.setFontSize(18);
  if (companyCode == 1178 || companyCode == 4971) {
    let title = new Image();
    title.src = Arabic;
    doc.addImage(title, "png", 50, 6, 150, 20);
  } else {
    doc.text(localStorage.getItem("company"), 50, 22);
  }

  doc.setFontSize(26);

  doc.text("WAREHOUSE BILL", 130, 45);

  doc.setFontSize(12);
  doc.setFontStyle("normal");

  doc.text("Date", 150, 53);
  doc.text(date, 165, 53);

  doc.text("Bill", 150, 61);
  doc.text(billNumber.toString(), 165, 61);

  doc.setFontSize(16);
  doc.text("Customer", 105, 61);
  doc.setFontStyle("normal");
  doc.setFontSize(12);
  doc.text(customer, 105, 68);

  doc.setFontSize(12);
  doc.text("Shop", 20, 52);

  doc.setFontStyle("normal");
  if (companyCode == 1178 || companyCode == 4971) {
    let title = new Image();
    title.src = address;
    doc.text("Darb public street next to Abu Qarn Station", 20, 65);
    doc.addImage(title, "png", 20, 66, 80, 5);
    doc.text(localStorage.getItem("phone") || "", 20, 80);
  } else {
    doc.text(localStorage.getItem("company") || "", 20, 58);
    let address = localStorage.getItem("address") || "";
    let phone = localStorage.getItem("phone") || "";
    let splitAddress = doc.splitTextToSize(address, 90);

    let position = 72;
    if (address.length >= 50 && address.length <= 100) {
      position = 75;
    } else if (address.length >= 100 && address.length <= 200) {
      position = 80;
    }

    doc.text(20, 65, splitAddress);
    doc.text(phone, 20, position);
  }

  var img = new Image();

  let baseUrl = localStorage.getItem("base_url");

  if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
    let snapshot = employeeLogo;
    img.src = snapshot;
  } else {
    let snapshot = localStorage.getItem("base_url");
    img.src = snapshot;
  }
  doc.addImage(img, "png", 0, 0, 40, 40);
  jsPDF.autoTableSetDefaults({
    headStyles: { fillColor: "#4daf51", font: "Amiri" },
    margin: { left: 8, right: 8, bottom: 10 },
    bodyStyles: { font: "Amiri" },
  });
  let col;
  if (BoxesPacking()) {
    col = ["#", "Item", "Quantity", "Boxes"];
  } else {
    col = ["#", "Item", "Quantity"];
  }
  let rows = [];
  items &&
    items.map((item, index) => {
      let saleQty = item.saleQuantity ? item.saleQuantity : 1;
      doc.setFontSize(14);
      if (BoxesPacking()) {
        let boxes = 0;
        if (item.saleQuantity && item?.packing) {
          let totalBox = parseFloat(item.saleQuantity) / item.packing;
          boxes = totalBox % 1 === 0 ? totalBox : totalBox.toFixed(2);
        } else {
          if (item.saleQuantity == undefined && item?.packing) {
            let totalBox = 1 / item.packing;
            boxes = totalBox % 1 === 0 ? totalBox : totalBox.toFixed(2);
          } else {
            boxes = "";
          }
        }
        let temp = [index + 1, item.name, saleQty, boxes];
        rows.push(temp);
      } else {
        let temp = [index + 1, item.name, saleQty];
        rows.push(temp);
      }
    });
  doc.autoTable(col, rows, { startY: 100 });

  let finalY = doc.lastAutoTable.finalY;

  doc.cell(20, finalY + 10, 100, 8, " ");
  doc.cell(20, finalY + 18, 100, 30, " ");
  doc.setFontSize(14);
  doc.text("Comments or Special Instructions", 22, finalY + 16);

  let arrs = "";

  for (var i = 0; i < notes?.length; i++) {
    if ((i + 1) % 30 == 0) {
      arrs = arrs + notes?.charAt(i) + "\n";
    } else {
      arrs = arrs + notes?.charAt(i);
    }
  }
  doc.text(arrs, 22, finalY + 22);

  doc.setFontSize(10);
  doc.text("Powered by www.managekaro.pk", 84, 285);
  doc.text("0331 5921209", 95, 290);

  if (temp == "standard_warehouse") {
    doc.setFontSize(10);
    if (window.innerWidth <= 600) {
      doc.save("reciept");
    } else {
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    }
  } else {
    doc.addPage();
    ThirdPrint(billNumber, customer, items, date, notes, doc);
  }
}

export default WarehousePrint;
